import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/les/dev/blob/layouts/default.vue").then(m => m.default || m))
}